module.exports = __webpack_public_path__ + "static/nuclear-terrorism-a74f0d552e16b8ab55b03bfb453b9158.jpg";